import { Input, type InputProps } from 'components/ui/input';
import { regionPhonePrefix } from 'environment';
import { forwardRef } from 'react';
import { PatternFormat } from 'react-number-format';
import type { PatternFormatProps } from 'react-number-format/types/types';

const DEFAULT_PHONE_FORMAT = `(${regionPhonePrefix}) ####################`;

type PhoneInputProps = InputProps &
  Omit<PatternFormatProps, 'format'> & { format?: string };

const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ format = DEFAULT_PHONE_FORMAT, ...props }, ref) => {
    return (
      <PatternFormat
        customInput={Input}
        format={format}
        getInputRef={ref}
        {...props}
      />
    );
  },
);

export { PhoneInput };
